import { Button } from "@alpacahq/ui/old";

import type { TransferCardControllerReturn } from "../TransferCard.controller";
import { WarningOctagonIcon } from "./WarningOctagonIcon";

interface WithdrawErrorProps
  extends Pick<TransferCardControllerReturn, "withdraw"> {}

export const WithdrawError = ({ withdraw }: WithdrawErrorProps) => (
  <div className="flex flex-col gap-4">
    <WarningOctagonIcon />
    <h3 className="m-0 p-0 font-semibold text-gray-950 text-lg">
      Withdrawal Failed
    </h3>
    <p className="m-0 p-0 font-medium text-gray-700 text-xs">
      {withdraw.error}
    </p>
    <Button
      variant="v2/stroke"
      size="v2/base"
      className="w-full border-gray-400"
      onClick={withdraw.onErrorOkClicked}
    >
      Ok
    </Button>
  </div>
);
